// --------------------------------------------
// Constants to be used in actions and reducers
// ---------------------------------------------
const PREFIX = 'KardiaRx.';

export const CCT_PATIENT_HISTORY_DATA_REQUEST = `${PREFIX}CCT_PATIENT_HISTORY_DATA_REQUEST`;
export const CCT_PATIENT_HISTORY_DATA_SUCCESS = `${PREFIX}CCT_PATIENT_HISTORY_DATA_SUCCESS`;
export const CCT_PATIENT_HISTORY_DATA_FAILURE = `${PREFIX}CCT_PATIENT_HISTORY_DATA_FAILURE`;
export const CCT_PATIENT_HISTORY_SELECTED_PATIENT = `${PREFIX}CCT_PATIENT_HISTORY_SELECTED_PATIENT`;
export const CCT_PATIENT_HISTORY_SELECTED_RECORDING = `${PREFIX}CCT_PATIENT_HISTORY_SELECTED_RECORDING`;

export const CCT_PATIENT_HISTORY_COMPLETED = `${PREFIX}CCT_PATIENT_HISTORY_COMPLETED`;
export const CCT_RESEND_EOS_REPORT = `${PREFIX}CCT_RESEND_EOS_REPORT`;



// WEBPACK FOOTER //
// ./src/views/state/KardiaRxCCTPatientHistory/types.js